/*
 * VENOM Technology — Collection Stock Ordering V71
 * Purpose: keep all products visible, globally partition the selected Shopify order as:
 *          IN STOCK first, OUT OF STOCK last, while retaining Shopify pagination.
 * Proprietary Venom storefront customization. See VENOM_PROPRIETARY_NOTICE_V66.txt.
 */
(function () {
  'use strict';

  const GRID_SELECTOR = '[data-venom-stock-order-grid]';
  const CARD_SELECTOR = 'product-card[data-venom-stock]';
  let runToken = 0;

  function pageUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    return url.toString();
  }

  function cardKey(card) {
    return card.getAttribute('data-product-id') ||
      (card.querySelector('a[href*="/products/"]') || {}).href ||
      card.textContent.trim().slice(0, 120);
  }

  function partition(cards) {
    const inStock = [];
    const outOfStock = [];
    cards.forEach(function (card) {
      if (card.getAttribute('data-venom-stock') === 'out-of-stock') outOfStock.push(card);
      else inStock.push(card);
    });
    return inStock.concat(outOfStock);
  }

  function updateShowing(total, inStockCount) {
    const el = document.getElementById('products-showing');
    if (!el) return;
    const sold = Math.max(0, total - inStockCount);
    el.textContent = total + ' منتج — ' + inStockCount + ' متاح' + (sold ? ' • ' + sold + ' غير متاح في الآخر' : '');
  }

  async function reorderGrid(grid) {
    if (!grid || grid.dataset.venomStockBusy === '1' || grid.dataset.venomStockDone === '1') return;

    const pages = Math.max(1, parseInt(grid.dataset.venomPages || '1', 10));
    const currentPage = Math.max(1, parseInt(grid.dataset.venomCurrentPage || '1', 10));
    const pageSize = Math.max(1, parseInt(grid.dataset.venomPageSize || '50', 10));

    // One page: server-side two-pass rendering is already globally correct.
    if (pages === 1) {
      const cards = Array.from(grid.querySelectorAll(':scope > ' + CARD_SELECTOR));
      const ordered = partition(cards);
      if (ordered.length) grid.replaceChildren.apply(grid, ordered);
      grid.dataset.venomStockDone = '1';
      updateShowing(ordered.length, ordered.filter(c => c.dataset.venomStock !== 'out-of-stock').length);
      return;
    }

    grid.dataset.venomStockBusy = '1';
    const token = ++runToken;

    try {
      const perPage = new Array(pages);
      perPage[currentPage - 1] = Array.from(grid.querySelectorAll(':scope > ' + CARD_SELECTOR));

      const requests = [];
      for (let page = 1; page <= pages; page++) {
        if (page === currentPage) continue;
        requests.push(
          fetch(pageUrl(page), { credentials: 'same-origin', headers: { 'X-Venom-Stock-Order': 'V71' } })
            .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
            .then(function (html) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const remoteGrid = doc.querySelector(GRID_SELECTOR);
              perPage[page - 1] = remoteGrid ? Array.from(remoteGrid.querySelectorAll(':scope > ' + CARD_SELECTOR)) : [];
            })
        );
      }
      await Promise.all(requests);
      if (token !== runToken || !document.contains(grid)) return;

      // Preserve the active Shopify sort order within each availability group.
      const seen = new Set();
      const all = [];
      perPage.forEach(function (cards) {
        (cards || []).forEach(function (card) {
          const key = cardKey(card);
          if (seen.has(key)) return;
          seen.add(key);
          all.push(card);
        });
      });

      const ordered = partition(all);
      const start = (currentPage - 1) * pageSize;
      const slice = ordered.slice(start, start + pageSize);
      const inStockCount = ordered.filter(c => c.dataset.venomStock !== 'out-of-stock').length;

      grid.replaceChildren.apply(grid, slice);
      grid.dataset.venomStockDone = '1';
      updateShowing(ordered.length, inStockCount);
    } catch (err) {
      // Fail safe: never break the collection page. Keep current server page ordered in-stock then sold-out.
      console.warn('[VENOM V71] Global stock ordering fallback:', err);
      const cards = Array.from(grid.querySelectorAll(':scope > ' + CARD_SELECTOR));
      const ordered = partition(cards);
      if (ordered.length) grid.replaceChildren.apply(grid, ordered);
      grid.dataset.venomStockDone = '1';
    } finally {
      delete grid.dataset.venomStockBusy;
    }
  }

  function run() {
    document.querySelectorAll(GRID_SELECTOR).forEach(reorderGrid);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  // Filters/sorting may replace the grid through AJAX. Re-apply to the new grid only.
  const observer = new MutationObserver(function () {
    window.clearTimeout(observer._venomTimer);
    observer._venomTimer = window.setTimeout(run, 80);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
